import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {},
  globalInjection: true,
  legacy: false,
})

async function fetchLocale(url) {
  const res = await fetch(url)
  return res.json()
}

export async function loadLocaleMessages(locale) {
  if (!i18n.global.availableLocales.includes('en-US')) {
    const data = await fetchLocale(window.context.i18n['en-US'])
    i18n.global.setLocaleMessage('en-US', data)
  }

  if (!i18n.global.availableLocales.includes(locale)) {
    const data = await fetchLocale(window.context.i18n[locale])
    i18n.global.setLocaleMessage(locale, data)
  }

  i18n.global.locale.value = locale
}

window.i18n = i18n
